// @core/api/endpoints/authn/authorize.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  AuthorizeRequest,
  AuthorizeResponse,
} from '../../../types/authn';

const BASE_PATH = '/authn';

/**
 * Initiate OAuth2 authorization flow
 * Starts the OAuth2 authorization code flow by validating client credentials and generating an authorization code. Supports PKCE and OIDC parameters for enhanced security.
 * @public This endpoint does not require authentication
 */
export async function Authorize(
  data: AuthorizeRequest,
  options?: RequestOptions
): Promise<AuthorizeResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/oauth2/authorize`;
  const requestOptions = { ...options, skipAuth: true };
  return client.post<AuthorizeResponse>(requestPath, data, requestOptions);
}
